<iframe class="easi-iframe" id="footer-container" [src]="iframe_url"></iframe>
